import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=16439e34&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=16439e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16439e34",
  null
  
)

export default component.exports